/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import Hidden from "@mui/material/Hidden";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import NumberFieldConfigured from "../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type IncomeUnemploymentAllowanceProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function IncomeUnemploymentAllowance({ submitProps, product }: IncomeUnemploymentAllowanceProps) {
  const { values, handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Einnahmen
            </Typography>
          </Hidden>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12}>
              <Group
                type={"radio"}
                name={"hasIncomeUnemploymentAllowance"}
                question={"Erhalten Sie Arbeitslosengeld I ?"}
                modalContent={
                  <p>
                    Zum Arbeitslosengeld I gehören nur die Leistungen aus dem 3. Sozialgesetzbuch(SGB II)I. NICHT die Leistungen nach dem Zweiten Buch
                    Sozialgesetzbuch (Hartz 4). Bitte prüfen Sie den Bescheid vom Arbeitsamt, um sicher zu gehen, welche Art von Arbeitslosengeld Sie erhalten.
                  </p>
                }
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasIncomeUnemploymentAllowance === "yes" && (
              <NumberFieldConfigured caseData={product} fieldPath={"incomeUnemploymentAllowanceAmount"} fieldType={"money"} numberType={"float"} required />
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
